import { render, staticRenderFns } from "./AuthoriseOpg.vue?vue&type=template&id=5411da0a&scoped=true"
import script from "./AuthoriseOpg.vue?vue&type=script&lang=js"
export * from "./AuthoriseOpg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5411da0a",
  null
  
)

export default component.exports